<template>

	<div class="edit-form__item">
		<div v-if="items.length<=0">-</div>		
		<div v-for="(item, index) in items">
			<div class="wc-label bold">
				<b v-if="item.type=='ADMIN'">推播回覆 </b> 
				<b v-else>客戶回報 </b> 
				<span class="wc-time">{{ item.created_at }}</span>：
				<div class="css-fix">{{ item.question }}</div>
				<b>備註:</b><div class="css-fix">{{ item.remark }}</div>
				<hr>
			</div>
		</div>
		<div style="margin-top:20px;">推播回覆 <span class="required">*</span></div>
		<wc-textarea								
			required
			class="wc-textarea"				
			rows="2"
			name="question"		
			model="question"	
			:value="question"
			@change="getQuestion"
			:disabled="question_status=='DONE' || question_status=='IMPROVE'"
		/>				
		<div style="margin-top:10px;">備註</div>			
		<wc-textarea											
			class="wc-textarea"				
			rows="3"
			name="remark"
			model="remark"	
			:value="remark"
			@change="getRemark"
			:disabled="question_status=='DONE' || question_status=='IMPROVE'"
		/> 
		<wc-button
		    class="btn btn-danger"
		    v-on:click="onClick"
		    :disabled="question_status=='DONE' || question_status=='IMPROVE'"
		>
		    立即推播回覆
		</wc-button>
		<!-- <textarea rows="4" cols="29" maxlength="524288" minlength="0" placeholder="" tabindex="0" style="min-height: 40px;">
		</textarea>		 -->
	</div>
</template>


<script>
import axios from "axios";
import '@25sprout-internal/wc-field';
import { config, apiPath } from "@backstagex/core/src/config";
import { isObject, isNil, clone } from 'lodash';
import { abstractField, slugify } from '@backstagex-vue-form-generator/core';
import icon from '@/components/atoms/Icon';

export default {
	mixins: [abstractField],
	props: ['schema', 'model'],
	components: {
		icon,
	},
	data() {
		return {
			question: '',
			remark: '',		
			question_status:''	
		};
	},
	computed: {
		items() {
			let values = this.schema.values;
			if (typeof values == 'function') {
				return values.apply(this, [this.model, this.schema]);
			} else return values;
		},
		
	},
	mounted:function(){
		var _this = this;
    axios
        .get(
            config.apiHost +
                "/api/backstagex/" +
                this.$route.params.menuItemKey +
                "/" +
                this.$route.params.id +
                "/opinion-status"				            
        )
        .then((response) => {           
          _this.question_status = response.data.data.data.question_status;          
        })
        .catch((err) => {
            console.log(err);
        });
	},
	methods: {
		onClick() {
		    var _this = this;		  
		    if(_this.question_status=='DONE' || _this.question_status=='IMPROVE') return;
		    //check
		    if(_this.question==""){
		    	alert("請填寫推播回覆");return;
		    }
		    // if(_this.remark==""){
		    // 	alert("請填寫備註");return;
		    // }

		    var confirm = window.confirm("您確定要立即推播回覆？");
		    if (confirm) {
		        axios
		            .post(
		                config.apiHost +
		                    "/api/backstagex/" +
		                    this.$route.params.menuItemKey +
		                    "/" +
		                    this.$route.params.id +
		                    "/insert-opinion-response"
			            ,{
			              	question: _this.question,
			              	remark: _this.remark
			             }
		            )
		            .then((response) => {
		                if (response.data.status === 200) {
		                    alert("推播回覆成功");
		                    this.$router.go(0);
		                } else {
		                    alert("推播回覆失敗");
		                }
		            })
		            .catch((err) => {
		                console.log(err);
		            });
		    }
		},
		getQuestion($event){
			let value = $event.target.value;
			this.question = value;			
		},	
		getRemark($event){
			let value = $event.target.value;
			this.remark = value;			
		},		
	},
};
</script>

<style scoped lang="scss">
.btn{
	margin-top:10px;
}
.wc-label{
	margin-bottom:20px !important;
	line-height: 30px !important;

}
.wc-time{
	font-size:12px;
	
}
.css-fix {
  white-space: pre-wrap; /* or pre-line */
}
.error-message {
	display: flex;

	.icon {
		margin-right: 4px;
	}
}
textarea {
	margin-top:30px;
    display: flex;
    padding: 9px 12px;
    border-width: 1px;
    border-style: solid;
    border-color: var(--textarea-border_color);
    border-radius: 4px;
    background-color: white;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 24px;
    letter-spacing: normal;
    color: var(--textarea-color);
    outline: none;
    width: 100%;
    font-family: var(--font-family);
    box-sizing: inherit;
}
.required{	
    font-weight: 400;
    color: red;
    padding-left: 0.2em;
    font-size: 1em;
}
</style>
